import { connect } from 'react-redux';
import paymentModule from 'app/store/payment';
import ReservationSuccess from './ReservationSuccess.component';
import orderModule from 'app/store/order';

const { purchaseRequest } = paymentModule.actions;
const { clearOrder } = orderModule.actions;

const mapDispatchToProps = {
  fetchPurchase: purchaseRequest,
  clearOrder
};

export default connect(
  null,
  mapDispatchToProps
)(ReservationSuccess);
